module.exports = __webpack_public_path__ + "img/20200529_142357.1a684829.jpg";